import { type KeyboardEvent, type FocusEvent, type MutableRefObject, useRef } from 'react';

const INVALID_CHARS = ['e', 'E', '+', '-'];
export const ALLOWED_KEY = [
    'Tab',
    'Backspace',
    'Enter',
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight'
];
export const ALLOWED_KEY_PRICE = [...ALLOWED_KEY, '.', ','];

// Block any char deefined in INVALID_CHARS
export const blockInvalidChar = (e: KeyboardEvent<HTMLInputElement>): boolean => {
    if (INVALID_CHARS.includes(e.key)) {
        e.preventDefault();
        return false;
    }

    return true;
};

// force type only number
export const forceNumber = (e: KeyboardEvent<HTMLInputElement>): boolean => {
    const isNumber = (/^\d+$/).test(e.key);
    const containAllowedKey = ALLOWED_KEY.includes(e.key);
    // no matter what i tried can't disallow user from typing "," "." "-" in mobile

    if (!isNumber && !containAllowedKey) {
        e.preventDefault();
        return false;
    }

    return true;
};

// number and dot and comma
export const forcePrice = (e: KeyboardEvent<HTMLInputElement>): boolean => {
    const isNumber = (/^\d+$/).test(e.key);
    const containAllowedKey = ALLOWED_KEY_PRICE.includes(e.key);

    if (!isNumber && !containAllowedKey) {
        e.preventDefault();
        return false;
    }

    return true;
};

// Forcing value to max and min
export const forceValue = (
    e: FocusEvent<HTMLInputElement>,
    callBack: (value: string) => void
): void => {
    const { value: targetValue, min, max } = e.target;

    if (targetValue === '') {
        callBack(targetValue);
    } else if (Number(targetValue) < Number(min) && callBack) {
        callBack(min);
    } else if (Number(targetValue) > Number(max) && callBack) {
        callBack(max);
    }
};

type UseFocus = [
    MutableRefObject<HTMLElement | null>,
    () => void
];

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useFocus = (): UseFocus => {
    const htmlElRef = useRef<HTMLElement>(null);
    const setFocus = (): void => {
        const currentEl = htmlElRef.current;
        if (currentEl) {
            currentEl.focus();
        }
    };

    return [htmlElRef, setFocus];
};
